import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const EarnMultiplierContainer = lazy(() => import("../components/EarnMultiplier"));

const EarnMultiplierRoute: RouteObject = {
  path: "settings/modules/retensee/earn-multiplier",
  element: <EarnMultiplierContainer />,
};

export default EarnMultiplierRoute;
